module.exports = __webpack_public_path__ + "media/images/icon_trash-855eec51bdaad299806bc18fa3ef663f.svg";